export enum Role {
  ADMIN = 'ADMIN',
  ORG_MEMBER = 'ORG_MEMBER',
  VENDOR_CASHIER = 'VENDOR_CASHIER'
}

interface Entity {
  id: string;
  name: string;
}

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  role: Role;
  active: boolean;
  emailVerified: boolean;
  organization?: Entity;
  vendor?: Entity;
  createdAt: Date;
}
